<aside class="rounded-2xl bg-white border border-gray-200 p-6 space-y-6">
  <h2 class="text-2xl font-extrabold mb-6 text-gray-900 tracking-tight">Filters</h2>

  <!-- Gender -->
  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Gender</h3>
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-700">
      @for (g of gender; track g) {
        <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
          <input
            type="checkbox"
            class="custom-check radio-like"
            [checked]="filters.gender === g"
            (change)="setGender(g)"
          />
          {{ g }}
        </label>
      }
    </div>
  </div>

  <!-- Product Type -->
  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Product Categories</h3>
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-700">
      @for (categorie of categories; track categorie) {
        <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
          <input
            type="checkbox"
            [value]="categorie"
            class="custom-check"
            (change)="toggleCategory(categorie)"
            [checked]="filters.categories.includes(categorie)"
          />
          {{ categorie }}
        </label>
      }
    </div>
  </div>

  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Design Themes</h3>
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-700">
      @for (theme of themes; track theme) {
        <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
          <input
            type="checkbox"
            [value]="theme"
            class="custom-check"
            (change)="toggleTheme(theme)"
          />
          {{ theme }}
        </label>
      }
    </div>
  </div>

  <!-- Color -->
  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Color</h3>
    <div class="flex flex-wrap gap-2">
      <div
        *ngFor="let color of colors"
        (click)="setColor(color)"
        [style.backgroundColor]="color.code"
        class="w-7 h-7 rounded-full cursor-pointer border-2 transition-transform hover:scale-110"
        [ngClass]="filters.color === color ? 'border-[var(--primary)]' : 'border-gray-300'"
      ></div>
    </div>
  </div>

  <!-- Sizes -->
  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Sizes</h3>
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-700">
      @for (size of sizes; track size) {
        <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
          <input type="checkbox" class="custom-check" [value]="size" (change)="toggleSize(size)" />
          {{ size }}
        </label>
      }
    </div>
  </div>

  <!-- Price Range -->
  <div>
    <h3 class="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Max Price</h3>
    <input
      type="range"
      min="0"
      max="5000"
      step="100"
      [(ngModel)]="filters.price"
      class="w-full accent-[var(--primary)] cursor-pointer"
    />
    <div class="text-sm font-bold text-[var(--primary)] mt-1">Up to Rs. {{ filters.price }}</div>
  </div>

  <!-- Apply Filters -->
  <button
    class="w-full py-3 bg-[var(--primary)] text-white rounded-xl border border-[var(--primary)] cursor-pointer font-bold hover:bg-gray-900 transition-colors"
    (click)="applyFilters()"
  >
    Apply Filters
  </button>
</aside>
